import { ITachographEventMetadata, IZoneEventMetadata } from './device-event.interface.dto';
import { IDeviceIdentificationObject } from './device-identification-object.interface';
import { EventTypeEnum } from '../enums';
import { ExternalIdSource } from '../types';

export interface IEventOutputDto {
    id: number;
    code: EventTypeEnum;
    description: string;
}

export interface IEventDeviceOutputDto {
    id: number;
    organizationId: string;
    externalId: string;
    externalIdSource: ExternalIdSource;
    name: string;
    code: string;
    identification: IDeviceIdentificationObject;
}

export interface IDeviceEventOutputDto {
    id: number;
    eventId: number;
    deviceId: number;
    latitude: string;
    longitude: string;
    timestamp: string;
    value?: string;
    metadata?: IZoneEventMetadata | ITachographEventMetadata | Record<string, unknown>;
    event: IEventOutputDto;
    device: IEventDeviceOutputDto;
}
